import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { Categorie } from '../../../shared/data/categorie';
import { plainToClass } from 'class-transformer';
import { Formation } from '../../../shared/data/formation';
import { Critere } from '../../../shared/data/critere';
import { EditCritereComponent } from '../../criteres/edit-critere/edit-critere.component';
import { Metier } from '../../../shared/data/metier';
import { Config } from '../../../config/config';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';

@Component({
  selector: 'ngx-edit-metier',
  templateUrl: './edit-metier.component.html',
  styleUrls: ['./edit-metier.component.scss']
})
export class EditMetierComponent implements OnInit {
  @Input() id: number;
  /* nome;
  desc;
  cate:any = []; */
  metierEdit = new Metier;
  hideLoader =true;
  hideButon =false;

  imagetype = '';

  // pr;

  /* 
  selectedItems = [];
  dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'chemin',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  formations: any[]; 
   */

  options: Critere[] = [];

  config = Config;

  constructor(protected dialogRef: NbDialogRef<EditMetierComponent>,private apiService:ApiService, private dialogService: NbDialogService, private router:Router,private sendeurService:EventSendeurService, public toastr: NbToastrService) {
  
    /* if( this.id !== 0 )
    this.getMetiers(); */

  }

  ngOnInit() {

    if(this.id !== 0)
    this.getOneMetier();

    this.apiService.getAllCritereProvider('').subscribe(data =>{
        this.options = data;
    })

    this.sendeurService.critereEvent.subscribe( data => {

      // console.log(data)

      const index = this.options.findIndex(elem => elem.id ===  data.id);

      if(index === -1) {

        this.options.push(data);

        if(data.type_critere === 'secteur_metier')
        this.metierEdit.secteur = data.id;

        if(data.type_critere === 'niveau')
        this.metierEdit.niveau = data.id;

        if(data.type_critere === 'salaire')
        this.metierEdit.salaire = data.id;

        if(data.type_critere === 'alternance')
        this.metierEdit.alternance = data.id;

        if(data.type_critere === 'selectivite')
        this.metierEdit.selectivite = data.id;

        if(data.type_critere === 'insertion')
        this.metierEdit.insertion = data.id;


        // console.log(this.metier)

      } 

      

    }) 

    this.sendeurService.image.asObservable().subscribe(data =>{

      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);

      // console.log(this.imageselect);

      if(this.imagetype === 'publication')
      this.metierEdit.photo = data;

      if(this.imagetype === 'video')
      this.metierEdit.image_video = data;


    })
   
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  

  updateMetier(){

    // console.log(this.metierEdit)

    if( this.id !== 0 ) {

      this.hideButon= true;
      this.hideLoader = false;
      this.apiService.updateMetierProvider(this.metierEdit).subscribe((data:Metier) =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success");
        this.dialogRef.close();
        this.sendeurService.sendMetierEvent(data); 

      },(err) =>{
        console.log(err);
        this.toastr.danger("echec de mise à jour réussie, un metier avec le même titre existe peut être déjà");
        this.hideButon= false;
        this.hideLoader = true;
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }
    
      })

    } else {


      this.hideLoader = false;
      this.hideButon = true;
      

      this.apiService.addMetierProvider(this.metierEdit).subscribe((data:Metier) =>{
        console.log(data);
        this.toastr.success("Metier crée avec success");
        this.dialogRef.close();
        this.sendeurService.sendMetierEvent(data); 
      },(err) =>{
        this.hideLoader = true;
        this.hideButon = false;
        this.toastr.danger("Il se peut qu'un metier portant le meme nom existe déjà","erreur");
        console.log(err);
      
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page","echec");
        }
    
    })



    }
    
  }

  getOneMetier(){

    this.apiService.getOneMetierProvider(this.id).subscribe(data =>{
     this.metierEdit = plainToClass(Metier, data as object);


    },(err) =>{

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })
  }

 
  

  onDropDownClose($event){
    
  }

  /* typeCatChanged($event){

    this.cat.type_content = $event;

  } */

  addSecteur() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'secteur_metier'}});
  }

  addNiveau() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'niveau'}});
  }

  addSalaire() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'salaire'}});
  }

  addAlternance() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'alternance'}});
  }

  addSelectivite() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'selectivite'}});
  }

  addInsertion() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'insertion'}});
  }


  /* addAdmissibility() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'admissibility'}});
  } */


  addImage(){
    this.imagetype = 'publication';
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }

  addVideoImage() {
    this.imagetype = 'video';
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }

  


}
